import { usePaginatedRequest } from "../../../../shared/hooks/usePaginatedRequest";
import { LinkedAccount } from "../../../../../models/Entities";
import { LinkedAccountsFilters } from "./useLinkedAccountsFilters";
import { buildLinkedAccountsParams } from "../utils/buildLinkedAccountsParams";

interface Params {
  filters: LinkedAccountsFilters;
  isTestAccounts: boolean;
  completeProductionDuplicatesOf?: string | null;
}

export const useLinkedAccountsList = ({
  filters,
  isTestAccounts,
  completeProductionDuplicatesOf,
}: Params) =>
  usePaginatedRequest<LinkedAccount>({
    rootPath: "/integrations/linked-accounts",
    paramsPath: buildLinkedAccountsParams({
      filters,
      isTestAccounts,
      completeProductionDuplicatesOf,
    }),
  });
